import { useTranslation } from 'react-i18next';
import { OverallTrialStatus, MatchingTrialStatus } from '@data/sdk/match';
import { Namespace } from '@data/utils/enums';

import { AntdTag } from '@ui/components';

const overallStatusColorMap: Record<OverallTrialStatus, string> = {
  ACTIVE_NOT_RECRUITING: 'processing',
  COMPLETED: 'success',
  ENROLLING_BY_INVITATION: 'processing',
  NOT_YET_RECRUITING: 'warning',
  RECRUITING: 'success',
  SUSPENDED: 'processing',
  TERMINATED: 'error',
  WITHDRAWN: 'error',
  AVAILABLE: 'default',
  NO_LONGER_AVAILABLE: 'error',
  TEMPORARILY_NOT_AVAILABLE: 'error',
  APPROVED_FOR_MARKETING: 'success',
  WITHHELD: 'error',
  UNKNOWN: 'default',
};

type OverallStatusProps = {
  status: OverallTrialStatus;
};

export const OverallStatus = ({ status }: OverallStatusProps) => {
  const { t } = useTranslation([Namespace.ADMIN]);
  return (
    <AntdTag color={overallStatusColorMap[status] || ''}>
      {t(`trials_library.trial.ct_statuses.${status}`)}
    </AntdTag>
  );
};

const statusColorMap: Record<MatchingTrialStatus, string> = {
  [MatchingTrialStatus.Processing]: 'default',
  [MatchingTrialStatus.Active]: 'success',
  [MatchingTrialStatus.Completed]: 'processing',
  [MatchingTrialStatus.Deleted]: 'error',
  [MatchingTrialStatus.Proposed]: 'warning',
};

type AppStatusProps = {
  status: MatchingTrialStatus;
};

export const AppStatus = ({ status }: AppStatusProps) => {
  const { t } = useTranslation([Namespace.ADMIN]);
  return (
    <AntdTag color={statusColorMap[status]}>{t(`trials_library.trial.statuses.${status}`)}</AntdTag>
  );
};
